import { render, staticRenderFns } from "./StockAdjustmentNoteInfo.vue?vue&type=template&id=af4bd672&scoped=true&"
import script from "./StockAdjustmentNoteInfo.vue?vue&type=script&lang=js&"
export * from "./StockAdjustmentNoteInfo.vue?vue&type=script&lang=js&"
import style0 from "./StockAdjustmentNoteInfo.vue?vue&type=style&index=0&id=af4bd672&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af4bd672",
  null
  
)

export default component.exports